import { updatePartnerUser } from '@common/api/account';
import { useNotificationsStore } from '@common/store/notifications';
import { PartnerQueryKeys } from '@common/types/query-keys';
import { SelectedPartnerUser } from '@pages/Admin/PartnerUsers/types/selectedPartnerUser';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UpdatePartner {
  payload: SelectedPartnerUser;
  id: number;
}

export const useUpdatePartnerUser = () => {
  const { addNotification } = useNotificationsStore();
  const queryClient = useQueryClient();

  const {
    mutate,
    isPending: isLoading,
    isSuccess
  } = useMutation({
    mutationFn: (data: UpdatePartner) => {
      return updatePartnerUser(data.payload, data.id);
    },
    onSuccess: () => {
      addNotification('success', 'Partner update successfully');
      queryClient.invalidateQueries({ queryKey: [PartnerQueryKeys.GET_PARTNER_USER_LIST] });
    },
    onError: () => {
      addNotification('fail', 'Failed to update partner');
    }
  });

  return {
    updatePartnerUser: mutate,
    isLoading,
    isSuccess
  };
};
